function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Twitter");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4 0H1.6C.72 0 0 .72 0 1.6v12.8c0 .88.72 1.6 1.6 1.6h12.8c.88 0 1.6-.72 1.6-1.6V1.6c0-.88-.72-1.6-1.6-1.6zm-1.84 5.84c-.08 3.68-2.4 6.24-5.92 6.4-1.44.08-2.48-.4-3.44-.96 1.04.16 2.4-.24 3.12-.88-1.04-.08-1.68-.64-2-1.52.32.08.64 0 .88 0-.96-.32-1.6-.88-1.68-2.16.24.16.56.24.88.24-.72-.4-1.2-1.92-.64-2.88C4.8 5.2 6.08 6.16 8.16 6.32c-.56-2.24 2.48-3.44 3.68-1.92.56-.08.96-.32 1.36-.48-.16.56-.48.88-.88 1.2.4-.08.8-.16 1.12-.32-.08.4-.48.72-.88 1.04z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.7bafc181.svg";
export { ForwardRef as ReactComponent };